import { Compass, Waves, Eye, Users, Route, Anchor } from "lucide-react";

export const BOOK_HOME = {
  title: "Ogni progetto ha bisogno di una rotta",
  text1: "La Rotta del Valore nasce dall'esperienza di Giovanni Luca Costantino e da un percorso fatto di mare, responsabilità, cambiamenti e nuove partenze. È un viaggio alla scoperta del valore nascosto nelle persone, negli immobili e nelle opportunità.",
  text2: "La stessa filosofia guida Home Haven: osservare ciò che altri non vedono, progettare la trasformazione e creare valore concreto e duraturo.",
};

export const BOOK_ABOUT = {
  title: "Un libro sul valore delle nuove partenze",
  paragraphs: [
    "La Rotta del Valore racconta il percorso di Giovanni Luca Costantino: dall'esperienza nella Polizia di Stato al comando di yacht, fino all'imprenditoria, alla gioielleria e allo sviluppo immobiliare.",
    "Esperienze apparentemente diverse, unite da uno stesso principio: ogni cambiamento può diventare una nuova rotta quando viene affrontato con visione, disciplina e coraggio.",
    "Attraverso 20 capitoli e sei appendici operative, il libro accompagna il lettore in una riflessione sul valore, sulle decisioni, sulle difficoltà e sulla possibilità di trasformare gli ostacoli in nuove opportunità.",
  ],
};

export const BOOK_THEMES = [
  { icon: Compass, title: "Individuare la rotta", text: "Imparare a definire una direzione anche nei momenti di incertezza." },
  { icon: Waves, title: "Affrontare il cambiamento", text: "Trasformare una fase difficile nell'inizio di un nuovo percorso." },
  { icon: Eye, title: "Riconoscere il valore", text: "Vedere il potenziale nelle persone, negli immobili e nelle opportunità." },
  { icon: Users, title: "Costruire l'equipaggio", text: "Scegliere collaboratori, partner e professionisti con cui condividere il viaggio." },
  { icon: Route, title: "Trasformare la visione", text: "Tradurre un'intuizione in un progetto concreto e sostenibile." },
  { icon: Anchor, title: "Arrivare in porto", text: "Misurare i risultati senza dimenticare il valore dell'esperienza compiuta." },
];

export const BOOK_METHOD = {
  title: "La filosofia del libro applicata agli immobili",
  paragraphs: [
    "Home Haven applica al settore immobiliare i principi raccontati ne La Rotta del Valore. Ogni operazione parte dall'osservazione di un potenziale ancora inespresso e prosegue attraverso progettazione, trasformazione e valorizzazione.",
    "Un immobile non viene considerato soltanto per ciò che è oggi, ma per quello che può diventare attraverso una visione chiara e un progetto economicamente sostenibile.",
  ],
  phases: [
    { title: "Scoperta", text: "Individuazione dell'immobile e del suo valore nascosto." },
    { title: "Visione", text: "Definizione della nuova identità e della strategia economica." },
    { title: "Trasformazione", text: "Progettazione, ristrutturazione e valorizzazione." },
    { title: "Valore", text: "Creazione del risultato per clienti, proprietari e investitori." },
  ],
};

export const AUTHOR = {
  name: "Giovanni Luca Costantino",
  role: "Imprenditore, sviluppatore immobiliare e uomo di mare",
  bio: [
    "Il mare gli ha insegnato che non è possibile controllare il vento, ma è sempre possibile correggere la rotta.",
    "Dopo l'esperienza nella Polizia di Stato e diversi anni trascorsi come comandante di yacht, Giovanni Luca Costantino ha intrapreso un nuovo percorso nel mondo dell'impresa, della gioielleria e dello sviluppo immobiliare.",
    "La Rotta del Valore nasce dall'incontro tra queste esperienze e racconta un modo personale di affrontare le decisioni, riconoscere le opportunità e trasformare una visione in un progetto concreto.",
  ],
};

export const INTEREST_OPTIONS = ["Lettore", "Investitore", "Proprietario di un immobile", "Potenziale cliente", "Professionista o partner", "Altro"];

export const SALE_LABEL = { preparazione: "In preparazione", prenota: "Prenota la tua copia", acquista: "Acquista ora" };
